import {HttpClient, HttpHandler} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';

@Injectable()

export class PollingCallbackApiClass extends HttpClient {
  private baseUrl = environment.baseUrlCallback + '/callback';

  public constructor(handler: HttpHandler) {
    super(handler);
  }

  public pollCallback(sessionToken): Observable<any> {
    const url = `${this.baseUrl}/payment/card/${sessionToken}`;
    return super.get(url);
  }

}
